import { graphql } from '@generated/gql';

export const FETCH_HOUSEHOLD_CUSTOM_FIELDS = graphql(/** GraphQL */ `
  query approvalFetchHouseholdCustomFields(
    $clientGroupId: SafeString!
    $keys: [String]
  ) {
    fetchClientGroup(input: { clientGroupId: $clientGroupId }) {
      clientGroup {
        id: stringId
        customFields(keys: $keys) {
          key
          value
          customField {
            id
            translatedName {
              ...OrganizationTranslatedString
            }
            translatedDescription {
              ...OrganizationTranslatedString
            }
            type
            format
            objectType
          }
          selectedOptions {
            value
            displayText {
              ...UserTranslatedString
            }
          }
        }
      }
    }
  }
`);

export const UPDATE_HOUSEHOLD_CUSTOM_FIELDS = graphql(/** GraphQL */ `
  mutation approvalUpdateHouseholdCustomFields(
    $input: UpdateClientGroupInput!
  ) {
    updateClientGroup(input: $input) {
      clientGroup {
        id
      }
    }
  }
`);
